const TON_DISPLAY_THRESHOLD_KG = 1_000_000;
const KILOGRAMS_PER_TON = 1_000;

export const shouldDisplayAsTons = (value: number) =>
  value >= TON_DISPLAY_THRESHOLD_KG;

export const formatWeightValue = (value: number) =>
  shouldDisplayAsTons(value)
    ? Math.round(value / KILOGRAMS_PER_TON).toLocaleString("en-US")
    : value.toLocaleString("en-US", { maximumFractionDigits: 2 });

export const formatWeightUnit = (value: number) =>
  shouldDisplayAsTons(value) ? "t" : "Kg";

export const formatWeightWithUnit = (value: number) =>
  `${formatWeightValue(value)} ${formatWeightUnit(value)}`;

export const formatKilogramValue = formatWeightValue;
